<mat-card>
  <h2>Schedule
    <hr>
  </h2>

  <div class="container">
    <form [formGroup]="scheduleForm">
      <mat-form-field class="example-full-width pd-bottom">
        <mat-label>{{scheduleNm}}</mat-label>
        <input type="text" matInput formControlName="skdName" placeholder="Schedule name" required>
        <mat-error *ngIf="scheduleForm.get('skdName')?.hasError('required')">Schedule name is required</mat-error>
      </mat-form-field>

      <div class="grid">
        <mat-form-field class="example-full-width">
          <mat-label>{{startDt}}</mat-label>
          <input matInput [matDatepicker]="startpicker" (focus)="startpicker.open()"
            (input)="dateValidation($event,'startDate')" autocomplete="off" formControlName="startDate" required
            min="{{ today | date:'yyyy-MM-dd' }}">
          <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
          <mat-datepicker #startpicker></mat-datepicker>
          <mat-error *ngIf="scheduleForm.get('startDate')?.hasError('required')">Start date is required</mat-error>
        </mat-form-field>

        <div class="flex time-select">
          <mat-icon>arrow_right_alt</mat-icon>
          <mat-form-field class="example-full-width">
            <mat-label>{{endDt}}</mat-label>
            <input matInput [matDatepicker]="endpicker" (focus)="endpicker.open()"
              (input)="dateValidation($event,'endDate')" formControlName="endDate" required
              [min]="scheduleForm.value.startDate || today | date:'yyyy-MM-dd'">
            <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
            <mat-datepicker #endpicker></mat-datepicker>
            <mat-error *ngIf="scheduleForm.get('endDate')?.hasError('required')">End date is required</mat-error>
          </mat-form-field>
        </div>

        <div class="time-select">
          <mat-icon class="icon">access_time</mat-icon>
          <mat-form-field class="example-full-width">
            <mat-label>{{scheduleTime}}</mat-label>
            <input matInput formControlName="skdTime" type="text" required (input)="dateValidation($event,'skdTime')"
              placeholder="Schedule time" [matAutocomplete]="timeAutocomplete">
            <mat-autocomplete #timeAutocomplete="matAutocomplete">
              <mat-option *ngFor="let time of timeOptions" [value]="time">{{ time }}</mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="scheduleForm.get('skdTime')?.hasError('required')">Schedule time is required</mat-error>
          </mat-form-field>
        </div>

        <div class="schedule-select">
          <mat-icon class="icon">repeat</mat-icon>
          <mat-form-field class="example-full-width">
            <mat-label>{{repeat}}</mat-label>
            <mat-select [(ngModel)]="scheduleForm.value.skdValue" matNativeControl formControlName="skdValue"
              placeholder="Schedule" required (ngModelChange)="onSkdValueChange()">
              <mat-option *ngFor="let option of skdValueOptions" [value]="option">{{ option }}</mat-option>
            </mat-select>
            <mat-error *ngIf="scheduleForm.get('skdValue')?.hasError('required')">Schedule repeat is
              required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</mat-card>
<br>